/* eslint-disable */
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { LoginCallback } from '@okta/okta-react'
import { Dashboard } from '@splunk-iteng/splunk-shared-components'
import { AdminStateType } from '../store/slices/admin.slice'
import { AppLevel } from '../graphql/components/base/appLevel'
import { SharedLevel } from '../graphql/components/base/sharedLevel'
import { SecureRoute } from '../auth/component/SecureRoute'

export interface AppRoutesProps extends AdminStateType {}
import { View } from '../components/DynamicViewComponent/View'
import { NotFound } from '../components/NotFound/NotFound'
import { Logout } from '../auth/component/Logout'
import { Unauthorized } from '../components/Unauthorized/Unauthorized'

export interface AppRoutes {
  sharedState: AdminStateType
}

export function AppRoutes(state: AppRoutesProps) {
  return (
    <Routes>
      <Route path="/" element={<SecureRoute />}>
        <Route
          path=""
          element={
            <Dashboard
              content={() => (
                <p className="text-sm p-2">Welcome to dashboard</p>
              )}
              title={'Dashboard'}
              showContent
            />
          }
        />
      </Route>
      <Route path="/support-admin" element={<SecureRoute />}>
        <Route
          index
          element={
            <Dashboard
              content={() => <p className="text-sm p-2"></p>}
              showContent={false}
              title={'Home'}
            />
          }
        />
      </Route>
      <Route path="/graphql-app" element={<SecureRoute />}>
        <Route
          path=""
          element={
            <div className="flex justify-items-center">
              <AppLevel />
            </div>
          }
        />
      </Route>
      <Route path="/graphql-shared" element={<SecureRoute />}>
        <Route
          path=""
          element={
            <div className="flex justify-items-center">
              <SharedLevel />
            </div>
          }
        />
      </Route>
      <Route path="/:path/:taskId" element={<SecureRoute />}>
        <Route path="" element={<View sharedState={state} />} />
      </Route>
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/*" element={<NotFound />} />
      <Route path="/login/callback" element={<LoginCallback />} />
      <Route path="/logout" element={<Logout />} />
    </Routes>
  )
}
